<script>
import SearchInputInner from "./SearchInputInner";
import sizeMixin from "../../../utils/sizeMixin";
import { getDefaultProp } from "../../../utils";

export default {
  components: { SearchInputInner },
  name: "SjSearchInput",
  mixins: [sizeMixin],
  props: {
    theme: {
      type: String, //border || card || darkbg // lightborder,
      default: "border"
    },
    allowEmpty: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default() {
        return getDefaultProp(
          this.$SJ_COMPONENTS_CONFIG?.SearchInput?.clearable,
          false
        );
      }
    },
    clearAfterSearch: {
      type: Boolean,
      default() {
        return getDefaultProp(
          this.$SJ_COMPONENTS_CONFIG?.SearchInput?.clearAfterSearch,
          false
        );
      }
    },
    clearForce: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String
    },
    arrowVisible: {
      type: Boolean,
      default: false
    },
    stopSearchClickEvent: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  data() {
    return {
      focused: false
    };
  },
  methods: {
    focus() {
      if (!this.disabled) {
        this.$refs.searchInner.focus();
      }
    }
  },
  render() {
    const {
      size,
      theme,
      $attrs,
      focused,
      allowEmpty,
      disabled,
      clearable,
      clearAfterSearch,
      clearForce,
      value,
      stopSearchClickEvent
    } = this;
    const Inner = (
      <SearchInputInner
        {...{ attrs: $attrs }}
        value={value}
        highlightFocus={theme === "border" || theme === "card"}
        highlightIcon={theme !== "lightborder"}
        dark={theme === "darkbg"}
        size={size}
        disabled={disabled}
        clearable={clearable}
        clearAfterSearch={clearAfterSearch}
        clearForce={clearForce}
        stopSearchClickEvent={stopSearchClickEvent}
        ref="searchInner"
        class="search_input_inner"
        onFocus={event => {
          this.$emit("focus", event);
          this.focused = true;
        }}
        onBlur={event => {
          this.$emit("blur", event);
          this.focused = false;
        }}
        onSearch={() => {
          if (allowEmpty) {
            this.$emit("search");
          } else {
            if (value) {
              this.$emit("search");
            } else {
              this.$SjNotify({
                message: "请输入搜索词",
                duration: 2000,
                type: "info"
              });
            }
          }
        }}
        onInput={key => {
          this.$emit("input", key);
        }}
        onEnter={ev => {
          this.$emit("enter", ev);
        }}
      ></SearchInputInner>
    );
    if (theme === "card") {
      return (
        <SjCard class={["search_input", `search-input-size-${size}`]}>
          {Inner}
        </SjCard>
      );
    } else {
      return (
        <div
          class={[
            "search_input",
            theme,
            { focus: focused },
            `search-input-size-${size}`
          ]}
        >
          {Inner}
        </div>
      );
    }
    // return Inner;
  }
};
</script>

<style scoped lang="less">

.search_input {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    overflow: hidden;
    each(@sizes, {
        &.search-input-size-@{value} {
            @size: "@{value}-size";
            height: @@size;
        }
    });

    .search_input_inner {
    }

    .border-style(){
        border-radius: @base-border-radius;
        border: @base-border-width @base-border-style;

        &.focus {
            border-color: @color-highlight;
        }
    }

    &.border {
        .border-style();
        border-color: @color-gray-4;
    }

    &.lightborder {
        .border-style();
        border-color: @color-gray-3;
    }
    &.darkbg{
        background-color:fade(@color-antibg,10);
        box-shadow:0px 4px 6px 0px rgba(144,164,183,0.22);
        border-radius:@base-border-radius;
    }
}
</style>
